/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';
import './ButtonCheckbox.scss';
import { appCheckboxSize, appKeyCode } from '@utils/globalConstant';
import { sanitizeRichText } from '@utils/sanitizeHtml';
import PropTypes from 'prop-types';

export function ButtonCheckbox({
  value = false,
  onChange = () => {},
  isDefaultChecked = false,
  name = '',
  id = '',
  // tAlly content pass from parent component
  checkboxContent = {},
  // checkboxLabelContent is not present then use label
  label = '',
  checkboxSize = appCheckboxSize.DEFAULT,
  isDisabled = false,
  valid = false,
  invalid = false,
  ...restProps
}) {
  // State
  const [isActive, setIsActive] = useState(value);

  // Function
  const toggleCheckbox = (event) => {
    if (event.type === 'keydown') {
      const { keyCode } = event;
      if (keyCode === appKeyCode.SPACE || keyCode === appKeyCode.ENTER) {
        event.preventDefault();
        setIsActive(!isActive);
      }
    } else {
      setIsActive(event.target.checked);
    }
  };

  const hasValidText = () => {
    if (checkboxContent && Object.keys(checkboxContent).length > 0) {
      if (checkboxContent.content !== "" && checkboxContent.content !== undefined) {
        return true;
      }
      return false;
    }
    if (label && label !== '') {
      return true;
    }
    return false
  }

  // Hooks
  useEffect(() => {
    onChange(isActive);
  }, [isActive]);

  useEffect(() => {
    if (value !== isActive) {
      setIsActive(value);
    }
  }, [value]);

  return (
    <div className="form-check">
      <input
        // {...(checkboxContent?.hasAriaLabel && { 'aria-label': checkboxContent?.ariaLabel })}
        id={id}
        name={name}
        checked={isActive || isDefaultChecked}
        className={`checkbox-input form-check-input 
          ${valid ? 'valid' : ''} 
          ${invalid ? 'invalid' : ''}`}
        value={isActive}
        onChange={toggleCheckbox}
        onKeyDown={toggleCheckbox}
        type="checkbox"
        disabled={isDisabled}
        aria-checked={isActive}
        {...{ ...restProps }}
      />
      {
        hasValidText() &&
        <>
          {
            checkboxContent?.isHtml ? 
              // eslint-disable-next-line jsx-a11y/label-has-associated-control
              <label htmlFor={id} dangerouslySetInnerHTML={{__html: sanitizeRichText(checkboxContent?.content || label || checkboxContent.ariaLabel)}}/> :
              <label htmlFor={id}>{checkboxContent?.content || label || checkboxContent.ariaLabel}</label>
          }
        </>
      }
    </div>
  );
}

ButtonCheckbox.propTypes = {
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
  isDefaultChecked: PropTypes.bool,
  name: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string,
  checkboxSize: PropTypes.string,
  isDisabled: PropTypes.bool
};

export default ButtonCheckbox;
